module.exports = __webpack_public_path__ + "img/vello-say-it-to-my-face.a104c6fa.png";